import React, { useState, useEffect, Fragment } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Regex from 'services/utils/regex/Regex';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { handleValidateObj } from 'constants/objValues/objvalues';

const GateSetup = ({ data, handleValue }) => {
  const [inputList, setInputList] = useState([
    { gate_no: 1, current_setup_id: '', tickting_method: '' },
  ]);
  const [listGate, setlistGate] = useState(data);
  const [gateval, setGateval] = useState({ id: null, value: '' });
  const [otherval, setOtherval] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [remark, setRemark] = useState('');

  const addGates = () => {
    if (gateval?.id === null || gateval?.value === '') {
      setIsValid(true);
      return false;
    }
    setIsValid(false);
    setInputList([...inputList, { current_setup_id: '', tickting_method: '' }]);
    setGateval({ id: null, value: '' });
    setOtherval(null);
  };
  const setGate = (name, value, index) => {
    const list = [...inputList];
    list[index][value] = name;
    list[index]['gate_no'] = index + 1;
    setInputList(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };
  useEffect(() => {
    if (data) {
      setlistGate(data.gateSetupTypes);
    }
  }, [data]);

  const handleFormData = () => {
    if (inputList.length > 0) {
      handleValue({
        gates: inputList,
      });
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handleFormData();
  }, [inputList]);

  return (
    <div className={isValid ? 'requiredFileds' : ''}>
      <FormSection title={localization.gateSetupTitle}>
        {inputList.map((gate, index) => {
          return (
            <div key={gate?.gate_no} className="w-100">
              <div className="full-width">
                <label className="label">
                  Gate no. {index + 1}{' '}
                  <a
                    onClick={() => handleRemoveClick(index)}
                    className="field-remove"
                  >
                    {localization.remove}
                  </a>
                </label>
              </div>
              <DropDownInput
                label={localization.gateFeature}
                inputValue={gate.current_setup_id}
                required={true}
                data={listGate}
                errorMsg={localization.requiredGateFeature}
                getIdValue={(val) => {
                  setGate(val.id, 'current_setup_id', index);
                }}
              />

              <DropDownInput
                label={localization.ticketingMethod}
                inputValue={gate.tickting_method}
                required={true}
                data={data && data.ticktingMethod}
                errorMsg={localization.isRequired}
                getIdValue={(val) => {
                  setGateval({ id: val?.id, value: val?.value });
                  setGate(val.id, 'tickting_method', index);
                  setRemark(index);
                }}
              />

              {gate.gate_no === remark + 1 && gateval.id === 'others' && (
                <ConstantInput
                  label={localization.remarks}
                  regex={Regex.charSpace.test(gate.tickting_method)}
                  errorMsg={localization.alphaErrorMg}
                  type="text"
                  handleChange={(val) => {
                    setOtherval(val);
                    setGate(val, 'tickting_method', index);
                  }}
                  className={gate.tickting_method.length ? '' : 'empty'}
                  required
                  isStarRequired={true}
                />
              )}
            </div>
          );
        })}

        <div className="form-group full-width">
          <a className="btn btn-transparent" onClick={addGates}>
            {localization.addAnotherGate}
          </a>
        </div>
      </FormSection>
    </div>
  );
};

export default GateSetup;
